module.exports = __webpack_public_path__ + "media/src/images/icons/file_icon_small-d90d58c26b91a93cd350aaf69e0b3679.svg";